import { Navigate, Route, Routes } from "react-router-dom";
import { RouteConstants } from "../constants/route";
import { useUser } from "../contexts/UserContext";
import Navigation from "../components/Navigation.tsx";
import styled from "styled-components";

// Routes
import RouteResolver from "../containers/RouteResolver.tsx";
import BrowseEmailLists from "../containers/BrowseEmailLists";
import UploadEmailList from "../containers/UploadEmailList";
import BrowseMarketingCampaigns from "../containers/BrowseMarketingCampaigns";
import CreateMarketingCampaign from "../containers/CreateMarketingCampaign";
import { useEffect } from "react";
import { useLoading } from "best-common-react";

const Container = styled.div``;

const Body = styled.div`
  height: 100%;
  width: 100%;
  margin-top: 1rem;
`;

const AuthenticatedApp = () => {
  const { roles } = useUser();
  const { setAnimated, setLabel } = useLoading();

  useEffect(() => {
    setAnimated(true);
    setLabel("…please wait a moment…");
  }, []);

  if (roles === undefined) return null;

  const canViewEmailLists = roles.includes("ROLE_EMAIL_LIST_LOAD");
  const canViewMarketingCampaigns = roles.includes("ROLE_MARKETING_QUERY_BUILD");

  return (
    <Container>
      <Navigation />
      <Body>
        <Routes>
          {canViewEmailLists && (
            <>
              <Route path={RouteConstants.EMAIL_LISTS.BROWSE} element={<BrowseEmailLists />} />
              <Route path={RouteConstants.EMAIL_LISTS.UPLOAD} element={<UploadEmailList />} />
            </>
          )}
          {canViewMarketingCampaigns && (
            <>
              <Route path={RouteConstants.MARKETING_CAMPAIGN.BROWSE} element={<BrowseMarketingCampaigns />} />
              <Route path={RouteConstants.MARKETING_CAMPAIGN.CREATE} element={<CreateMarketingCampaign />} />
            </>
          )}
          <Route path={RouteConstants.BASE} element={<RouteResolver />} />
          <Route path={RouteConstants.WILDCARD} element={<Navigate to={RouteConstants.BASE} replace />} />
        </Routes>
      </Body>
    </Container>
  );
};

export default AuthenticatedApp;
